import { createQueryKeyStore } from "@lukemorales/query-key-factory";

export const queryKeys = createQueryKeyStore({
    clients: {
        all: null,
    },
    jurisdictions: {
        all: null,
        byId: (id: string) => [id],
    },
    entities: {
        all: null,
        byId: (id: string) => [id],
    },
    reports: {
        all: null,
        byId: (id: string) => [id],
    },
    users: {
        all: null,
        byId: (id: string) => [id],
    },
});
